import Api from '@/api/api.js'

// Sociétés à convention directe (04/10/2026) : contrat unique, travailleurs pré-enregistrés et leur famille.
export default {
    contrats(assurance_id) {
        return Api().get('/assurances/' + assurance_id + '/souscripteurs/liste').then(response => response.data)
    },
    souscripteurs(assurance_id) {
        return Api().get('/assurances/souscripteurs/' + assurance_id + '/liste').then(response => response.data)
    },
    champsTaux(assurance_id) {
        return Api().get('/assurances/souscripteurs/' + assurance_id + '/taux/champs').then(response => response.data)
    },
    enregistrerContrat(data) {
        return Api().post('/assurances/souscripteurs/store', data).then(response => response.data)
    },
    // Facturation du contrat (préfixe, forfait, n° de bon, durée) : mêmes routes que Caisse › Paramètres › Sociétés.
    infoSociete(souscripteur_id) {
        return Api().get('/assurances/souscripteurs/' + souscripteur_id + '/get-info-societe').then(response => response.data)
    },
    enregistrerInfoSociete(data) {
        return Api().post('/assurances/souscripteurs/update-info-societe', data).then(response => response.data)
    },
    souscripteursGroupes() {
        return Api().post('/assurances/liste-souscripteurs', {}).then(response => response.data)
    },
    sexes() {
        return Api().get('sexes').then(response => response.data)
    },
    membres(assurance_id) {
        return Api().get('/assurances/' + assurance_id + '/membres').then(response => response.data)
    },
    rechercher(assurance_id, q) {
        return Api().get('/assurances/' + assurance_id + '/membres/recherche', { params: { q } }).then(response => response.data)
    },
    enregistrerMembre(assurance_id, data) {
        return Api().post('/assurances/' + assurance_id + '/membres', data).then(response => response.data)
    },
    activerMembre(membre_id, actif) {
        return Api().put('/assurances/membres/' + membre_id + '/actif', { actif }).then(response => response.data)
    },
    supprimerMembre(membre_id) {
        return Api().delete('/assurances/membres/' + membre_id).then(response => response.data)
    },
}
